import { formatDate } from "@angular/common";
import { Injectable } from "@angular/core";



@Injectable()
export class ExportService {

  constructor() {}

  convertToCSV(objArray, headerList) {
    let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    console.log(objArray);
    let str = "";
    let row = "S.No;";
    for (let index in headerList) {
      row += headerList[index] + ";";
    }
    row = row.slice(0, -1);
    str += row + "\r\n";
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + "";
      for (let index in headerList) {
        let head = headerList[index];
        let data = array[i][head];

        line += ';' + data;
      }
      str += line + "\r\n";
    }
    return str;
  }

  exportJson(campaign, exportLeads) {
    let name = campaign.name + "_" + Date.now() + ".json";
    this.downloadFile(
      JSON.stringify(exportLeads, null, 2),
      name,
      "application/json"
    );
  }

   //CSV : text/csv;charset=utf-8;
  downloadFile(data, filename = "data", type) {
    let blob = new Blob(["\ufeff" + data], { type });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename);
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  extractAddressField(label, address) {
    console.log(label,address)
  if (!address || typeof address !== 'object') return '';

  switch (label) {
    case "provinciaResidenza":
    case "address.provincia":
    case "provincia":
      return address.provincia || address.name || '';
    case "capResidenza":
    case "cap":
    case "zip":
      return address.zipcode || '';
    case "cittaResidenza":
    case "address.name":
    case "città":
      return address.name || '';
    default:
      return '';
    }
  }

  extractBirthday(rawValue) {
  return `${rawValue.day || ''}/${rawValue.month || ''}/${rawValue.year || ''}`;
  }

  convertUnixToDate(unixTimestamp: number): string {
    const date = new Date(unixTimestamp); // Se è in secondi, altrimenti togli * 1000
    return formatDate(date, 'dd/MM/yy', 'en-US'); // Puoi cambiare 'en-US' in base alla localizzazione
  }

  generateNameSurname(name){
    // è stato fatto perche molti dati arrivano con solo il first_name e full_name popolati.
    // il last_name non è popolato

    if (name.last_name) {
      return { first: name.first_name, last: name.last_name };
    }

    // In case first_name and last_name are undefined return an empty string
    // some might be saved ad name and surname so we can skip them.
    // need to quit with first name and last name as empty strings
    if (typeof name.first_name === 'undefined' && typeof name.full_name === 'undefined') {
      return { first: "", last: ""}
    }

    const sorgente = name.first_name ? name.first_name : name.full_name;

    const [first, ...altre] = sorgente.split(' ');
    const last = altre.join(' ');

    return{first, last}
  }

  flattenData(rawValue){
    return JSON.stringify( typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue)
                    .replace(/\\n|\\r|[\n\r]/g, '')   // rimuove newline
                    .replace(/\\"/g, '"');            // rimuove escape alle virgolette
  }

  formatPhoneForCSV(phone){
    if (phone.startsWith('+')) {
      // Protegge il valore dall'interpretazione in Excel
      return '="' + phone + '"';
    }
    return phone;
  }
}
